import { combineReducers } from 'redux';
import tripSlice from './trip/trip.slice';
import userSlice from './user/user.slice';

export const rootReducer = combineReducers({
  user: userSlice.reducer,
  trip: tripSlice.reducer,
});
